<div class="inline-textarea-wrapper">
  @if (!isEditing) {
    <span>
      @if (!value) {
        <a (click)="startEdit()" class="add"> Add text </a>
      }
      @if (value) {
        <span>
          {{ value }}
          @if (value) {
            <button class="edit-button" mat-icon-button (click)="startEdit()">
              <mat-icon class="edit-icon">edit</mat-icon>
            </button>
          }
        </span>
      }
    </span>
  }
  <div
    class="editing"
    [ngClass]="{
      hidden: !isEditing,
    }"
    >
    <textarea
      matInput
      class="editable"
      type="text"
      name="value"
      maxlength="400"
      [placeholder]="placeholder"
      #editInput
      [(ngModel)]="pendingValue"
      (keydown.enter)="confirmEdit()"
      (keydown.escape)="cancelEdit()"
      [required]="required"
    ></textarea>

    <div class="button-container">
      <button mat-button (click)="cancelEdit()">CANCEL</button>
      <button mat-button class="save" (click)="confirmEdit()">SAVE</button>
    </div>
  </div>
</div>
